function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 21.6V14.568C21.5999 11.112 20.8559 8.472 16.8239 8.472C14.8799 8.472 13.5839 9.528 13.0559 10.536H13.0079V8.784H9.19189V21.6H13.1759V15.24C13.1759 13.56 13.4879 11.952 15.5519 11.952C17.5919 11.952 17.6159 13.848 17.6159 15.336V21.576H21.5999V21.6Z",
    fill: "#0077B5",
    style: {
      fill: "#0077B5",
      fill: "color(display-p3 0.0000 0.4667 0.7098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71191 8.784H6.69591V21.6H2.71191V8.784Z",
    fill: "#0077B5",
    style: {
      fill: "#0077B5",
      fill: "color(display-p3 0.0000 0.4667 0.7098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7039 2.39999C3.4319 2.39999 2.3999 3.43199 2.3999 4.70399C2.3999 5.97599 3.4319 7.03199 4.7039 7.03199C5.9759 7.03199 7.0079 5.97599 7.0079 4.70399C7.0079 3.43199 5.9759 2.39999 4.7039 2.39999Z",
    fill: "#0077B5",
    style: {
      fill: "#0077B5",
      fill: "color(display-p3 0.0000 0.4667 0.7098)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/iconLinkedin.10ae032bd5cca12bc4f774666ffb15f0.svg";
export { ForwardRef as ReactComponent };